'use client';

import { useMemo } from 'react';

import { useSearchParams } from 'next/navigation';

export const useUrlQuery = (query: string) => {
  const search = useSearchParams();
  const memo = useMemo(() => new URLSearchParams(search), [search]);

  return memo.get(query);
};
